import Foundation from "@microsoft/fast-components-foundation-react";
import { ListboxItem as BaseListboxItem } from "@microsoft/fast-components-react-base";
import { classNames } from "@microsoft/fast-web-utilities";
import React from "react";
import { DisplayNamePrefix } from "../utilities";
class SelectOption extends Foundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            glyph: void 0,
            value: void 0,
            id: void 0,
            managedClasses: void 0,
        };
    }
    render() {
        const { selectOption, selectOption__disabled, selectOption__selected, selectOption_contentRegion, } = this.props.managedClasses;
        return (React.createElement(BaseListboxItem, Object.assign({}, this.unhandledProps(), { id: this.props.id, displayString: this.props.displayString, value: this.props.value, managedClasses: {
                listboxItem: selectOption,
                listboxItem__disabled: selectOption__disabled,
                listboxItem__selected: selectOption__selected,
            } }),
            this.renderGlyph(),
            React.createElement("span", { className: classNames(selectOption_contentRegion) },
                this.props.displayString,
                this.props.children)));
    }
    renderGlyph() {
        if (typeof this.props.glyph === "function") {
            return this.props.glyph(
            // TODO: https://github.com/microsoft/fast/issues/2125
            classNames(this.props.managedClasses.selectOption_glyph));
        }
        return null;
    }
}
SelectOption.displayName = `${DisplayNamePrefix}SelectOption`;
SelectOption.defaultProps = {
    managedClasses: {},
};
export default SelectOption;
export * from "./select-option.props";
